module.exports = __webpack_public_path__ + "static/pinkcardi-7fd179436d5ca6632062b5c98d076610.jpeg";